/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelsCountResponse } from '../../models/travels-count-response';

export interface TravelControllerCount$Params {
}

export function travelControllerCount(http: HttpClient, rootUrl: string, params?: TravelControllerCount$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelsCountResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerCount.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelsCountResponse;
      }>;
    })
  );
}

travelControllerCount.PATH = '/travel/count';
